import useMutation from '@space-shell/common/hooks/useMutation'
import type { EditFollowerRoleArgs } from '@space-shell/common/services/communities'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'
import { queryClient } from '@space-shell/config/request'

export const useEditFollowerRole = () => {
  return {
    editFollowerRoleQuery: useMutation<void, EditFollowerRoleArgs>(
      (payload: EditFollowerRoleArgs) => CommunitiesService.editFollowerRole(payload)
    ),
    invalidateFollowersQueries: async (communityId: number) => {
      await Promise.all([
        queryClient.invalidateQueries([CommunitiesEndpoints.getFollowersRoles(Number(communityId))])
      ])
    }
  }
}
